var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header"},[_c('div',{staticClass:"headercenter",on:{"click":_vm.goHome}},[_c('img',{staticClass:"logmng",attrs:{"src":require("@/assets/login.png")}}),_c('div',[_vm._v(_vm._s(_vm.biaoTi))])])])}
var staticRenderFns = []

export { render, staticRenderFns }